export const AFTER_MEAL = 'After Meal';
export const BEFORE_MEAL = 'Before Meal';

const PROPERTIES = {
    med: {
        Frequency: [
            { n: 'SOS' },
            { n: 'Stat' },
            { n: '0-0-1' },
            { n: '0-1-0' },
            { n: '1-0-0' },
            { n: '0-1-1' },
            { n: '1-0-1' },
            { n: '1-1-0' },
            { n: '1-1-1' },
            { n: 'Once Every 1 Day' },
            { n: 'Once Every 1 Week' },
            { n: 'Once Every 1 Hour' },
            { n: 'Once Every 1 Month' },
            { n: 'Once Every 1 Year' },
            { n: '0-0-1/2' },
            { n: '0-1/2-0' },
            { n: '0-1/2-1/2' },
            { n: '1/2-1/2-1/2' },
            { n: '1/2-0-0' },
            { n: '1/2-0-1/2' },
            { n: '1/2-1/2-0' },
            { n: '0-0-2' },
            { n: '0-2-0' },
            { n: '0-2-2' },
            { n: '2-2-2' },
            { n: '2-0-0' },
            { n: '2-0-2' },
            { n: '2-2-0' },
            { n: '0-0-3' },
            { n: '0-3-0' },
            { n: '0-3-3' },
            { n: '3-3-3' },
            { n: '3-0-0' },
            { n: '3-0-3' },
            { n: '3-3-0' },
            { n: 'Once Every 2 Days' },
            { n: 'Once Every 2 Weeks' },
            { n: 'Once Every 2 Hours' },
            { n: 'Once Every 2 Months' },
            { n: 'Once Every 3 Days' },
            { n: 'Once Every 3 Weeks' },
            { n: 'Once Every 3 Hours' },
            { n: 'Once Every 3 Months' },
            { n: 'Once Every 4 Days' },
            { n: 'Once Every 4 Weeks' },
            { n: 'Once Every 4 Hours' },
            { n: 'Once Every 4 Months' },
            { n: 'Once Every 5 Days' },
            { n: 'Once Every 5 Weeks' },
            { n: 'Once Every 5 Hours' },
            { n: 'Once Every 5 Months' },
            { n: 'Once Every 6 Days' },
            { n: 'Once Every 6 Weeks' },
            { n: 'Once Every 6 Hours' },
            { n: 'Once Every 6 Months' },
        ],
        'Dose Timing': [
            {
                n: AFTER_MEAL,
            },
            {
                n: BEFORE_MEAL,
            },
            {
                n: 'With Meal',
            },
            {
                n: 'Empty Stomach',
            },
            { n: 'Before Breakfast' },
            { n: 'After Breakfast' },
            { n: 'Before Lunch' },
            { n: 'After Lunch' },
            { n: 'Before Dinner' },
            { n: 'After Dinner' },
            { n: 'Along With Food' },
            { n: 'At Bed Time' },
            { n: 'On Waking Up' },
            { n: '30 Mins Before Food' },
            { n: 'Not Related To Food Intake' },
            { n: 'Before Bath' },
            { n: 'After Bath' },
            { n: 'Before Sun Exposure' },
            { n: 'After Sun Exposure' },
            { n: 'Before Breakfast, Lunch And Dinner' },
            { n: 'After Breakfast, Lunch And Dinner' },
            { n: 'Before Breakfast And Dinner' },
            { n: 'After Breakfast And Dinner' },
            { n: 'Before Breakfast And Lunch' },
            { n: 'After Breakfast And Lunch' },
            { n: 'Before Lunch And Dinner' },
            { n: 'After Lunch And Dinner' },
        ],
    },
    symptom: {
        Severity: [
            {
                id: 'mild',
                name: 'Mild',
            },
            {
                id: 'Moderate',
                name: 'Moderate',
            },
            {
                id: 'Severe',
                name: 'Severe',
            },
        ],
        MdbProperties: [
            {
                name: 'Since',
                id: 'pg-1541659976',
                type: 'prefix-suggest',
                order: 100,
                properties: [
                    {
                        id: 'pr-2328162781',
                        name: 'Hour',
                        name_p: 'Hours',
                    },
                    {
                        id: 'pr-2328192567',
                        name: 'Day',
                        name_p: 'Days',
                    },
                    {
                        id: 'pr-2328252156',
                        name: 'Week',
                        name_p: 'Weeks',
                    },
                    {
                        id: 'pr-2328281948',
                        name: 'Month',
                        name_p: 'Months',
                    },
                    {
                        id: 'pr-2328311730',
                        name: 'Year',
                        name_p: 'Years',
                    },
                ],
            },
            {
                name: 'Severity',
                id: 'pg-2869689919',
                type: 'radio',
                order: 400,
                properties: [
                    {
                        id: 'pr-2439595566',
                        name: 'Moderate',
                    },
                    {
                        id: 'pr-2945090243',
                        name: 'Severe',
                    },
                    {
                        id: 'pr-9637082164',
                        name: 'Mild',
                    },
                ],
            },
            {
                name: 'Note',
                id: 'pg-5243973452',
                type: 'open-text-box',
                order: 10000,
                properties: [
                    {
                        id: 'pr-1655490178',
                        name: 'Plain text',
                    },
                ],
            },
        ],
    },
    diagnosis: {
        Status: [
            {
                id: 'Confirmed',
                name: 'Confirmed',
            },
            {
                id: 'Suspected',
                name: 'Suspected',
            },
            {
                id: 'Ruled Out',
                name: 'Ruled Out',
            },
        ],
        MdbProperties: [
            {
                name: 'Since',
                id: 'pg-1541659976',
                type: 'prefix-suggest',
                order: 100,
                properties: [
                    {
                        id: 'pr-2328162781',
                        name: 'Hour',
                        name_p: 'Hours',
                    },
                    {
                        id: 'pr-2328192567',
                        name: 'Day',
                        name_p: 'Days',
                    },
                    {
                        id: 'pr-2328252156',
                        name: 'Week',
                        name_p: 'Weeks',
                    },
                    {
                        id: 'pr-2328281948',
                        name: 'Month',
                        name_p: 'Months',
                    },
                    {
                        id: 'pr-2328311730',
                        name: 'Year',
                        name_p: 'Years',
                    },
                ],
            },
            {
                name: 'Status',
                id: 'pg-903506519',
                type: 'radio',
                order: 300,
                properties: [
                    {
                        id: 'pr-903506519',
                        name: 'Confirmed',
                    },
                    {
                        id: 'pr-903536309',
                        name: 'Ruled out',
                    },
                    {
                        id: 'pr-910745738',
                        name: 'Suspected',
                    },
                ],
            },
            {
                name: 'Note',
                id: 'pg-5243973452',
                type: 'open-text-box',
                order: 10000,
                properties: [
                    {
                        id: 'pr-1655490178',
                        name: 'Plain text',
                    },
                ],
            },
        ],
    },
    symDia: {
        Duration: [
            { n: '1 Day' },
            { n: '2 Days' },
            { n: '3 Days' },
            { n: '4 Days' },
            { n: '5 Days' },
            { n: '6 Days' },
            { n: '7 Days' },
            { n: '1 Week' },
            { n: '2 Weeks' },
            { n: '3 Weeks' },
            { n: '1 Hour' },
            { n: '2 Hours' },
            { n: '3 Hours' },
            { n: '4 Hours' },
            { n: '5 Hours' },
            { n: '6 Hours' },
            { n: '8 Days' },
            { n: '9 Days' },
            { n: '10 Days' },
            { n: '11 Days' },
            { n: '12 Days' },
            { n: '13 Days' },
            { n: '14 Days' },
            { n: '15 Days' },
            { n: '16 Days' },
            { n: '17 Days' },
            { n: '18 Days' },
            { n: '19 Days' },
            { n: '20 Days' },
            { n: '21 Days' },
            { n: '22 Days' },
            { n: '23 Days' },
            { n: '24 Days' },
            { n: '25 Days' },
            { n: '26 Days' },
            { n: '27 Days' },
            { n: '28 Days' },
            { n: '29 Days' },
            { n: '1 Month' },
            { n: '2 Months' },
            { n: '3 Months' },
            { n: '4 Months' },
            { n: '5 Months' },
            { n: '6 Months' },
            { n: '7 Months' },
            { n: '8 Months' },
            { n: '9 Months' },
            { n: '10 Months' },
            { n: '11 Months' },
            { n: '12 Months' },
            { n: '1 Year' },
            { n: '2 Years' },
            { n: '3 Years' },
            { n: '4 Weeks' },
            { n: '5 Weeks' },
            { n: '6 Weeks' },
            { n: '7 Weeks' },
            { n: '8 Weeks' },
            { n: '7 Hours' },
            { n: '8 Hours' },
            { n: '9 Hours' },
            { n: '10 Hours' },
            { n: '11 Hours' },
            { n: '12 Hours' },
        ],
    },
    injection: {
        Route: [
            { n: 'IM' },
            { n: 'IVI' },
            { n: 'IV' },
            { n: 'ID' },
            { n: 'SC' },
            { n: 'IA' },
            { n: 'IO' },
        ],
    },
};

export default PROPERTIES;
